import React from "react";
import { useTranslation } from "react-i18next";
import { PlaneIcon } from "./icons";

export const FlightAlertsHeader: React.FC = () => {
  const { t } = useTranslation("flightAlerts");
  return (
    <div className="flex items-center gap-2">
      <PlaneIcon className="w-5 h-5 text-brand-blue" />
      {/* Figma spec: Lexend Deca, Regular 400, 14px/18px, 0 letter-spacing,
          ink/100 (#0F151A) — same on mobile and desktop (DASH-6077). */}
      <span className="font-lexend text-[14px]/[18px] font-normal tracking-normal text-ink-100">
        {t("shared.logoTitle")}
      </span>
    </div>
  );
};
